/* eslint-disable max-len */
export default {
    en: {
        advisorAppointment: '/en/form/advisor-appointment-new/24',
        appointment: '/en/express-visit',
        buildAndQuote: '/en/new-catalog/{make}/{model}/buildmy-{make}-{model}-{bodyStyle}?year={year}',
        buildAndQuoteV25: '/en/new-catalog/{make}/{model}/buildmy-{make}-{model}-{bodyStyle}-id{vehicleId}?year={year}',
        carfaxForm:
            '/en/form/inventory/carproof-request/27?desired_make={make}&desired_model={model}&desired_year={year}&desired_trim={trim}&desired=inventory&stocknumber={stock}&carId={id}',
        catalog: '/en/shop-online',
        catalogNew: '/en/new-catalog', // V2.5
        catalogMarketplace: '/en/new-catalog/{make}/{year}-{make}-{model}-id{vehicleId}', // V2.5
        certified: '/ir/h45/images/manufacturer/{make}/{make}-certified-color-best-en.png',
        checkout: '/en/checkout',
        financing: '/en/financing-request',
        homepage: '/en',
        listingUsed: '/en/used-inventory',
        listingPreOwnedUsed: '/en/pre-owned-inventory',
        listingNew: '/en/new-inventory',
        testDriveForm:
            '/en/form/road-test-used/18?desired_make={make}&desired_model={model}&desired_year={year}&carId={id}&stocknumber={stock}&desired=inventory',
        thankyou: '/en/thank-you',
        tradeIn: '/en/trade-in-appraisal',
        tradeInOfficial: '/en/trade-in-appraisal?view=official',
        tradeInEstimated: '/en/trade-in-appraisal?view=estimated',
        newTradeInOfficial: '/en/trade-in-appraisal?noEstimate=true&new=true',
        existingTradeInOfficial: '/en/trade-in-appraisal?view=official',
        editExistingTradeInOfficial: '/en/trade-in-appraisal?view=official&officialEdit=true',
        newTradeInAppraisal: '/en/trade-in-appraisal?new=true', // Redirect to vehicle info step for official evaluation
        tradeInAppointment: '/en/trade-in-appraisal?view=appointment',
        tradeInView: '/en/trade-in-appraisal?view=view',
        priceQuoteFormUsed:
            '/en/form/inventory/price-request/17?carId={id}&desired_make={make}&desired_model={model}&stocknumber={stock}&desired_year={year}&desired_trim={trim}&desired=inventory',
        priceQuoteFormNew:
            '/en/form/inventory/price-request/72?carId={id}&trimId={trimId}&desired_make={make}&desired_model={model}&stocknumber={stock}&desired_year={year}&desired_trim={trim}&desired=inventory',
        soldPriceQuoteFormUsed:
            '/en/form/inventory/price-request/25?carId={id}&desired_make={make}&desired_model={model}&stocknumber={stock}&desired_year={year}&desired_trim={trim}&desired=inventory',
        soldPriceQuoteFormNew:
            '/en/form/inventory/price-request/83?carId={id}&trimId={trimId}&desired_make={make}&desired_model={model}&stocknumber={stock}&desired_year={year}&desired_trim={trim}&desired=inventory',

        privacyPolicy: '/en/privacy-policy',
        vdp: '/en/used-inventory/{make}/{model}/{year}-{make}-{model}-id{vehicleId}',
        vdpNew: '/en/new-inventory/{make}/{model}/{year}-{make}-{model}-id{vehicleId}',
        marketPlaceVdp: '/en/inventory/{make}/{model}/{year}-{make}-{model}-id{vehicleId}',
        tradeInAppraisal: '/en/form/cant-find-your-vehicle/113',
        tradeInAppraisalV25: '/en/form/cant-find-your-vehicle/113',
        tradeInAppraisalV25Dilawri: '/en/form/42',
        tradeInEstimatedDilawri: '/en/form/4',
    },
    fr: {
        advisorAppointment: '/fr/formulaire/rendez-vous-avec-un-conseiller-neuf/24',
        appointment: '/fr/visite-express',
        buildAndQuote: '/fr/catalogue-neuf/{make}/{model}/construisezvotre-{make}-{model}-{bodyStyle}?year={year}',
        buildAndQuoteV25:
            '/fr/catalogue-neuf/{make}/{model}/construisezvotre-{make}-{model}-{bodyStyle}-id{vehicleId}?year={year}',
        carfaxForm:
            '/fr/formulaire/demande-de-carproof-occasion/27?desired_make={make}&desired_model={model}&desired_year={year}&desired_trim={trim}&desired=inventory&stocknumber={stock}&carId={id}',
        catalog: '/fr/magasiner-en-ligne',
        catalogNew: '/fr/catalogue-neuf', // V2.5
        catalogMarketplace: '/fr/catalogue-neuf/{make}/{make}-{model}-{year}-id{vehicleId}', // V2.5
        certified: '/ir/h45/images/manufacturer/{make}/{make}-certified-color-best-fr.png',
        checkout: '/fr/commande',
        financing: '/fr/demande-de-financement',
        homepage: '/fr',
        listingUsed: '/fr/inventaire-occasion',
        listingPreOwnedUsed: '/fr/inventaire-occasion',
        listingNew: '/fr/inventaire-neuf',
        testDriveForm:
            '/fr/formulaire/essai-routier-occasion/18?desired_make={make}&desired_model={model}&desired_year={year}&carId={id}&stocknumber={stock}&desired=inventory',
        thankyou: '/fr/vous-remercie',
        tradeIn: '/fr/evaluation-echange',
        tradeInOfficial: '/fr/evaluation-echange?view=officiel',
        tradeInEstimated: '/fr/evaluation-echange?view=estimation',
        newTradeInOfficial: '/fr/evaluation-echange?noEstimate=true&new=true',
        existingTradeInOfficial: '/fr/evaluation-echange?view=officiel',
        editExistingTradeInOfficial: '/fr/evaluation-echange?view=official&officialEdit=true',
        newTradeInAppraisal: '/fr/evaluation-echange?new=true', // Redirect to vehicle info step for official evaluation
        tradeInAppointment: '/fr/evaluation-echange?view=rendez-vous',
        tradeInView: '/fr/evaluation-echange?view=voir',
        priceQuoteFormUsed:
            '/fr/formulaire/inventaire/demande-de-prix/17?carId={id}&desired_make={make}&desired_model={model}&stocknumber={stock}&desired_year={year}&desired_trim={trim}&desired=inventory',
        priceQuoteFormNew:
            '/fr/formulaire/inventaire/demande-de-prix/72?carId={id}&trimId={trimId}&desired_make={make}&desired_model={model}&stocknumber={stock}&desired_year={year}&desired_trim={trim}&desired=inventory',
        soldPriceQuoteFormUsed:
            '/fr/formulaire/inventaire/demande-de-prix/25?carId={id}&desired_make={make}&desired_model={model}&stocknumber={stock}&desired_year={year}&desired_trim={trim}&desired=inventory',
        soldPriceQuoteFormNew:
            '/fr/formulaire/inventaire/demande-de-prix/83?carId={id}&trimId={trimId}&desired_make={make}&desired_model={model}&stocknumber={stock}&desired_year={year}&desired_trim={trim}&desired=inventory',

        privacyPolicy: '/fr/politique-confidentialite/',
        vdp: '/fr/inventaire-occasion/{make}/{model}/{make}-{model}-{year}-id{vehicleId}',
        vdpNew: '/fr/inventaire-neuf/{make}/{model}/{make}-{model}-{year}-id{vehicleId}',
        marketPlaceVdp: '/fr/inventaire/{make}/{model}/{make}-{model}-{year}-id{vehicleId}',
        tradeInAppraisal: '/fr/formulaire/impossible-de-trouver-votre-vehicule/113',
        tradeInAppraisalV25: '/fr/formulaire/impossible-de-trouver-votre-vehicule/113',
        tradeInAppraisalV25Dilawri: '/fr/formulaire/42',
        tradeInEstimatedDilawri: '/fr/formulaire/4',
    },
};
